import { RouteConfig } from 'vue-router';
import { PermissionTypeEnum } from '../Api';
import ReportedMaintenance from './pages/ReportedMaintenance.vue';

export default [
    {
        path: '/:tenantId/reported-maintenance',
        name: 'ReportedMaintenance',
        component: ReportedMaintenance,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.PerformAudit, PermissionTypeEnum.Response, PermissionTypeEnum.MistakeCorrection],
            checkLicence: true,
            title: 'menu.reportedMaintenance',
        },
    },
] as RouteConfig[];
